import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Popover, message } from "antd";
import { find } from 'lodash';

import * as constants from '../../constants';
import LegalGroundForm from './LegalGroundForm';

import core from '../../../core';
import uistate from '../../../uistate';
import globalappstate from '../../../globalappstate';
import common from '../../../../common';

const { GenericTable } = core;


class LegalGroundsGrid extends Component {

    state = {
        addFormVisible: false,
        editFormVisible: false,
        currentEditEntity: {},
    };

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'LegalGroundsGrid', key);
    }

    //#region Grid button handlers

    onAddClicked = (e) => {
        this.setState({
            currentEditEntity: { idProcessingActivity: this.props.idProcessingActivity, Id: -1 },
            addFormVisible: true,
        });
    }
    onDeleteClicked = (idx) => {
        this.props.arrayHelper.remove(idx);
    }

    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityAdd = (values) => {
        values.forEach(i => {
            this.props.arrayHelper.push(i);
        });
        this.setState({
            addFormVisible: false,
            currentEditEntity: {},
        });
    }

    //#endregion

    render() {
        const readOnly = this.props.readOnly ? this.props.readOnly : false;
        const columns = [{
            title: this.label('LegalGroundName'),
            dataIndex: 'legalGroundName',
            key: 'legalGroundName',
            sorter: (a, b) => ('' + a.legalGroundName).localeCompare(b.legalGroundName),
        }];

        return (
            <div className='legalgrounds'>
                <GenericTable aligntop multiline columns={columns} data={this.props.items} keyfield='idx' itemName={this.label('LegalGroundItem')} pagesize={5}
                    onAdd={this.onAddClicked}
                    readOnly={readOnly}
                    onDelete={this.onDeleteClicked} />

                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.addFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <LegalGroundForm picklists={this.props.picklists} labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityAdd} />
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {

    })
    (LegalGroundsGrid);  